export const useThemeToggle = () => {
  const handleChange = (e: string) => {
    localStorage.setItem('themeName', e.toLocaleLowerCase());
    window.location.reload();
  };

  return { handleChange };
};
